import { createShallowStore, createStoreWithPersistAndSubscribe } from '@frontend/store';

interface IntegrationsDashboardStore {
  isUserAuthenticated: boolean;
  isUserLoggingIn: boolean;
  isUserRefreshing: boolean;
  setIsUserAuthenticated: (isAuthenticated: boolean) => void;
  setIsUserLoggingIn: (isClicked: boolean) => void;
  setIsUserRefreshing: (isRefreshing: boolean) => void;
  resetState: () => void;
}

const initialState = {
  isUserAuthenticated: false, //True if user is authenticated, false otherwise.
  isUserLoggingIn: false, //True when login process starts, false when it ends.
  isUserRefreshing: false, //True when user triggers a data refresh, false when it ends.
};

export const useIntegrationsDashboardStore = createStoreWithPersistAndSubscribe<IntegrationsDashboardStore>(
  (set) => ({
    ...initialState,
    setIsUserAuthenticated: (isAuthenticated: boolean) => {
      set({ isUserAuthenticated: isAuthenticated });
    },
    setIsUserLoggingIn: (isClicked: boolean) => {
      set({ isUserLoggingIn: isClicked });
    },
    setIsUserRefreshing: (isRefreshing: boolean) => {
      set({ isUserRefreshing: isRefreshing });
    },
    resetState: () => {
      set(initialState);
    },
  }),
  {
    name: 'IntegrationsDashboard',
  },
  {
    name: 'IntegrationsDashboardStore',
    enabled: true,
  }
);

export const useIntegrationsDashboardShallowStore =
  createShallowStore<IntegrationsDashboardStore>(useIntegrationsDashboardStore);
